export const getPoster = ({ useDefaultThumbnail, customThumbnailType, customThumbnailTimestamp, customThumbnailImage, playbackId, startTime, }) => {
    const defaultThumbnail = `https://image.mux.com/${playbackId}/thumbnail.jpg`;
    const customThumbnailFromTimestamp = !useDefaultThumbnail &&
        customThumbnailType === 'timestamp' &&
        customThumbnailTimestamp &&
        defaultThumbnail.concat(`?time=${customThumbnailTimestamp}`);
    const customThumbnailFromImage = !useDefaultThumbnail &&
        customThumbnailType === 'upload' &&
        (customThumbnailImage === null || customThumbnailImage === void 0 ? void 0 : customThumbnailImage.file.url);
    const startTimeThumbnail = typeof startTime === 'number'
        ? startTime >= 0 && defaultThumbnail.concat(`?time=${startTime}`)
        : null;
    return (startTimeThumbnail ||
        customThumbnailFromTimestamp ||
        customThumbnailFromImage ||
        defaultThumbnail);
};
export const getIsControlButtonTarget = (target) => {
    return (target.nodeName === 'svg' ||
        target.nodeName === 'path' ||
        target.nodeName === 'BUTTON' ||
        target.nodeName === 'SPAN');
};
//# sourceMappingURL=utils.js.map